// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-002430e0] .van-tab {\n  font-size: 15px;\n  color: #999999;\n}\n[data-v-002430e0] .van-tab--active {\n  color: #333333;\n  font-weight: 600;\n}\n[data-v-002430e0] .van-tabs__line {\n  display: none;\n}\n[data-v-002430e0]::-webkit-scrollbar {\n  display: none;\n}\n[data-v-002430e0]::-webkit-scrollbar-track {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
